export default "__VITE_ASSET__18eb80e1__"